
import mongoose from 'mongoose'
import { setBaseSchema } from '../core/schema/Schema'

const Schema = mongoose.Schema

const RoomFormatSchema = new Schema({
	id: { type: String, default: "" },
	name: { type: String, default: "" },
	code: { type: String, default: "" },
	description: { type: String, default: "" },
}, { _id: false })

setBaseSchema(RoomFormatSchema, "room_format")

RoomFormatSchema.methods.setData = function (data) {
	try {
		if (!!data) {
			this.id = data._id
			this.name = data.name
			this.code = data.code
			this.description = data.description
		}
	} catch (error) {

	}
}

RoomFormatSchema.methods.serializeOption = function () {
	try {
		let result = {
			key: this.id,
			text: this.name,
			value: this.id,
		}

		return result
	} catch (error) {
		return null
	}
}


const RoomFormatModel = mongoose.model("room_format", RoomFormatSchema, "room_format")

export default RoomFormatModel